import { useState } from "react";
import { formatTimeStr } from "../lib/format";
import { I } from "./primitives";

const KIND_LABEL = {
  crit: "Over Limit",
  recover: "Recovered",
  offline: "Offline",
  online: "Online",
  test: "Test",
};

const KIND_STATUS = {
  crit: "crit",
  recover: "ok",
  offline: "crit",
  online: "ok",
  test: "ok",
};

export function LogsPage({ logs, loading, error, refresh }) {
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  const filtered = logs.filter((l) => {
    if (filter === "sent" && !l.delivered) return false;
    if (filter === "failed" && l.delivered) return false;
    if (q.trim() && !(l.serverName || "").toLowerCase().includes(q.trim().toLowerCase())) {
      return false;
    }
    return true;
  });

  return (
    <div className="page" style={{ padding: 0, display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "24px 28px 16px" }}>
        <h1 className="page-title">Log Notifikasi</h1>
        <p className="page-sub">
          Riwayat seluruh notifikasi yang dikirim ke Telegram.{" "}
          {loading && <span style={{ color: "var(--text-3)" }}>Loading…</span>}
          {error && (
            <span style={{ color: "var(--crit)" }}>Gagal memuat: {error.message}</span>
          )}
        </p>

        <div className="flex items-center gap-3">
          <div className="input" style={{ width: 260 }}>
            <I.search />
            <input
              placeholder="Cari berdasarkan nama server…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
          <div className="status-counts">
            <button data-active={filter === "all"} onClick={() => setFilter("all")}>Semua</button>
            <button data-active={filter === "sent"} onClick={() => setFilter("sent")}>
              <span className="swatch ok" />Terkirim
            </button>
            <button data-active={filter === "failed"} onClick={() => setFilter("failed")}>
              <span className="swatch crit" />Gagal
            </button>
          </div>
          <div style={{ flex: 1 }} />
          <button className="btn" onClick={refresh} type="button" title="Refresh">
            <I.refresh />
            <span>Refresh</span>
          </button>
        </div>
      </div>

      <div className="table-wrap" style={{ borderTop: "1px solid var(--border-soft)" }}>
        <table className="logs">
          <thead>
            <tr>
              <th style={{ width: 170 }}>Waktu</th>
              <th style={{ width: 180 }}>Server</th>
              <th style={{ width: 90 }}>Metrik</th>
              <th style={{ width: 140 }}>Nilai</th>
              <th>Pesan</th>
              <th style={{ width: 120 }}>Status</th>
              <th style={{ width: 70 }} />
            </tr>
          </thead>
          <tbody>
            {filtered.map((l) => (
              <tr key={l.id}>
                <td style={{ color: "var(--text-2)" }}>{formatTimeStr(l.ts)}</td>
                <td>
                  <div className="flex items-center gap-2">
                    <span style={{ color: "var(--text)" }}>{l.serverName}</span>
                  </div>
                </td>
                <td>
                  <span
                    className="status-badge"
                    data-status={KIND_STATUS[l.kind]}
                  >
                    {l.metric === "test" ? "TEST" : l.metric.toUpperCase()}
                  </span>
                </td>
                <td>
                  {l.value != null ? (
                    <>
                      <span style={{ color: l.kind === "crit" ? "var(--crit)" : "var(--text)", fontWeight: 600 }}>
                        {Math.round(l.value)}%
                      </span>
                      {l.threshold != null && (
                        <span style={{ color: "var(--text-4)" }}> / {Math.round(l.threshold)}%</span>
                      )}
                    </>
                  ) : (
                    <span style={{ color: "var(--text-4)" }}>—</span>
                  )}
                </td>
                <td className="col-msg" style={{ whiteSpace: "pre-line" }}>
                  {l.message}
                </td>
                <td>
                  <span className="status-badge" data-status={l.delivered ? "ok" : "crit"}>
                    {l.delivered ? "Terkirim" : "Gagal"}
                  </span>
                  {!l.delivered && l.error && (
                    <div className="text-xs mono" style={{ color: "var(--text-4)", marginTop: 2 }}>
                      {l.error.length > 40 ? `${l.error.slice(0, 40)}…` : l.error}
                    </div>
                  )}
                </td>
                <td>
                  <span className="text-xs mono" style={{ color: "var(--text-4)" }}>
                    {KIND_LABEL[l.kind] ?? l.kind}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!loading && filtered.length === 0 && (
          <div className="empty-state">
            {logs.length === 0 ? (
              <>
                <div>Belum ada log notifikasi</div>
                <div className="text-sm" style={{ marginTop: 4 }}>
                  Notifikasi akan muncul di sini setelah alerting fire untuk pertama kali.
                </div>
              </>
            ) : (
              <div>Tidak ada log notifikasi yang cocok</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
